import React from "react";
import ServiceTemplate from "./ServiceTemplate";
import { Building2 } from "lucide-react";

const serviceData = {
  id: "batiments",
  title: "Électricité des bâtiments",
  description: "Solutions électriques pour bâtiments tertiaires et industriels",
  icon: Building2,
  image: "/Electricitebatiment.jpg", // Ensure this is the correct file name and path
  longDescription: [
    "Notre expertise en électricité des bâtiments couvre tous les aspects des installations électriques pour les secteurs tertiaire et industriel. Nous concevons et mettons en œuvre des solutions adaptées à vos besoins spécifiques.",
    "De la conception à la maintenance, nous assurons la conformité et l'efficacité de vos installations électriques, tout en optimisant la consommation énergétique de vos bâtiments.",
  ],
  features: [
    "Installation électrique complète",
    "Distribution électrique HTA/BT",
    "Éclairage intelligent",
    "Gestion technique du bâtiment",
    "Bornes de recharge véhicules électriques",
    "Systèmes de sécurité électrique",
  ],
  benefits: [
    "Optimisation énergétique",
    "Conformité aux normes en vigueur",
    "Solutions évolutives",
    "Maintenance préventive",
    "Intervention rapide 24/7",
  ],
};

const BatimentsElectricite: React.FC = () => {
  return <ServiceTemplate service={serviceData} />;
};

// Ensure this is present
export default BatimentsElectricite;
